import React, { Fragment } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

/* atoms */
import { Invalid } from '../feedbacks';
/* atoms */

/*
: properties
name,
label,
value,
onChange,
helperText,
error
*/

// ponytail: FormControlLabel does the row layout, so a label that wraps stays
// aligned with its own first line instead of running back under the tick.
const checkbox = (props) => {
  const { name, value, label } = props;
  const control = value
    ? <Checkbox checked value={name} {...props} style={{ padding: 0 }} />
    : <Checkbox value={name} {...props} style={{ padding: 0 }} />;
  return <Fragment>
    <FormControlLabel
      style={{ alignItems: 'flex-start', marginLeft: 0, marginRight: 0 }}
      control={control}
      label={<span style={{ display: 'block', lineHeight: 1.3, paddingLeft: 8 }}>{label}</span>}
    />
    <Invalid {...props} />
  </Fragment>
}

export default checkbox;
